<template>
  <span
    ><slot></slot>
    <b-sidebar
      id="add-sdk-message"
      sidebar-class="big_sidebar create-sdk-message"
      :title="$t('MESSAGES.TYPE.sdk-message')"
      v-model="show"
      right
      backdrop
      shadow
      no-slide
      lazy
      no-close-on-backdrop
      no-close-on-esc
      no-header-close
      @shown="shown"
      @hidden="closeBtn"
    >
      <b-overlay :show="loading" rounded="sm">
        <div class="view-content compose-content create-message px-3 py-2 pb-5" v-if="settings">

          <b-alert v-if="settings.environment == 'QA'" show variant="warning" class="pt-2 pb-2">
            <div v-html="$t('SDK.ENVIRONMENT.QA_NOTIFICATION')"></div>
          </b-alert>
          <b-alert v-if="settings.environment == 'OPEN_TEST'" show variant="warning" class="pt-2 pb-2">
            <div v-html="$t('SDK.ENVIRONMENT.OPEN_TEST_NOTIFICATION')"></div>
          </b-alert>

          <div v-if="step == 1">
            <div v-if="showFrom">
              <div class="info-header mt-2">{{ $t("FROM") }}</div>
              <b-form-select
                class="mt-2"
                v-model="selected_functionbox_uuid"
                :options="functionbox_options"
              ></b-form-select>
            </div>
            <div class="info-header mt-2">{{ $t("TO") }}</div>
            <div v-if="!to_sdk" class="mb-2">{{ $t("NONE_SELECTED") }}</div>
            <div v-if="to_sdk" class="mb-2">
              <div class="sdk-recipient">
                {{ to_sdk.attributes.name }}
                <div
                  v-if="to_sdk.attributes.name != to_sdk.attributes.description"
                >
                  <small>{{ to_sdk.attributes.description }}</small>
                </div>
              </div>
            </div>
            <div>
              <b-button size="sm" variant="primary" @click="addSdkRecipient">
                <i class="fal fa-bookmark"></i>
                {{ $t("SDK.SELECT_RECIPIENT") }}
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                @click="addNewSdkParticipant"
              >
                <i class="fal fa-search"></i>
                {{ $t("SDK.SELECT_FROM_ADRESSBOOK") }}
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                @click="addWithIdentifier = true"
              >
                <i class="fal fa-plus"></i>
                {{ $t("SDK.ADD_WITH_IDENTIIER") }}
              </b-button>
            </div>

            <b-modal
              id="add-sdk-with-identiier"
              v-model="addWithIdentifier"
              hide-header
              @cancel="cancelAddIdentifier"
              @ok="okAddIdentifier"
              :ok-disabled="identifier == ''"
              :dialog-class="teams.theme"
              centered
              :cancel-title="$t('CANCEL')"
              :ok-title="$t('ADD')"
            >
              <b-form-input trim
                v-model="identifier"
                :placeholder="$t('SDK.IDENTIFIER')"
              ></b-form-input>
            </b-modal>

            <div class="info-header mt-2">{{ $t("INFORMATION") }}</div>

            <b-form-input trim
              class="mt-2"
              input-id="subject"
              :placeholder="$t('SUBJECT')"
              autocomplete="off"
              v-model="subject"
            ></b-form-input>

            <b-form-textarea
              class="mt-2 p-2 textarea"
              autocomplete="off"
              id="messageContent"
              input-id="message"
              v-model="content"
              :placeholder="$t('CONTENT')"
              rows="6"
              max-rows="6"
            ></b-form-textarea>
            <b-form-invalid-feedback :state="content.length < 20000">
              {{ $t("ERROR.TOO_MANY_CHARACTERS") }}
            </b-form-invalid-feedback>
            <div class="text-right">
              <small class="pull-right">{{ content.length }}/20000</small>
            </div>

            <form class="mt-2">
              <FileSelect
              :max-size="GetMaxTotalBytesAllowedToSendSDKMessage"
              v-model="files"
                file-type="application/pdf"
                class="mt-2"
              >
                <b-button size="sm" variant="secondary" class="no-border">
                  <i class="fal fa-plus"></i> {{ $t("ADD_FILES") }} ({{
                    files.length + attachments.length
                  }})
                  <i
                    class="fal fa-info-circle"
                    v-b-tooltip.hover
                    :title="$t('SDK.PDF_FORMAT')"
                  ></i>
                </b-button>
              </FileSelect>
            </form>

            <div class="mt-2" :key="'attachments_' + (attachments.length + files.length)">
              <div :class="filesClass">
              <span v-if="attachments.length != 0">
                <span
                  v-for="(item, index) in attachments"
                  :key="index"
                  class="ms-fontSize-12"
                >
                  <Attachment
                    @removeFile="removeAttachment"
                    :item="item"
                    :index="index"
                  ></Attachment>
                </span>
              </span>
              <span v-if="files.length != 0">
                <span
                  v-for="(item, index) in files"
                  :key="index"
                  class="ms-fontSize-12"
                >
                  <Attachment
                    @removeFile="removeFile"
                    :item="item"
                    :index="index"
                  ></Attachment>
                </span>
              </span>
            </div>
          </div>

          <div class="error-text" v-if="!ValidateFileSize(currentFilesize)">
            {{ $t("ERROR.LARGE_FILES") }} {{ this.GetMaxTotalBytesAllowedToSendSDKMessage+"MB" }}
          </div>
    

            <b-button
              size="sm"
              variant="secondary"
              @click="step = 2"
              class="no-border"
            >
              <i class="fal fa-plus"></i>&nbsp;
              <span v-if="metadataItemsCount == 0">{{
                $t("SDK.ADD_EXTRA_INFO_EMPTY")
              }}</span>
              <span v-if="metadataItemsCount != 0">{{
                $t("SDK.ADD_EXTRA_INFO", { "0": metadataItemsCount })
              }}</span>
            </b-button>

            <hr class="p-0 m-0 mt-2 mb-2" />

            <b-button @click="closeBtn">{{ $t("CLOSE") }}</b-button>

            <b-button
              :disabled="disabledGotoStep2"
              @click="preSendMessage"
              variant="primary"
              class="btn-fill"
              >{{ $t("SUBMIT") }}</b-button
            >
          </div>
          <div v-if="step == 2">
            <SDKReferences
              :key="referencesKey"
              @cancel="cancelReferences"
              :fromParticipantPersons="fromParticipantPersons"
              :fromParticipantReferences="fromParticipantReferences"
              :toParticipantPersons="toParticipantPersons"
              :toParticipantReferences="toParticipantReferences"
              @ok="setReferences"
            ></SDKReferences>
          </div>
          <div v-if="step == 5">
            <SDKSearch
              @cancel="goBackStep1"
              @selectedAddress="selectedAddress"
              :functionbox_uuid="selected_functionbox_uuid"
            ></SDKSearch>
          </div>
          <div v-if="step == 4">
            <SDKRecipients
              @cancel="goBackStep1"
              @selectedAddress="selectedAddress"
              :functionbox_uuid="selected_functionbox_uuid"
            ></SDKRecipients>
          </div>
        </div>
      </b-overlay>
    </b-sidebar>
  </span>
</template>
<script>
import * as blobUtil from "blob-util";
import SDKSearch from "@/components/Input/SDK/SdkSearch_4_2";
import SDKReferences from "@/components/Input/SDK/SdkReferences";
import SDKRecipients from "@/components/Input/SDK/SdkRecipients_4_2";
import FileSelect from "@/components/Compose/FileSelect";
import Attachment from "@/components/Compose/Attachment";
export default {
  props: {
    replyComplete: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    reply_identifier: {
      default: "",
      type: String,
    },
    reply_organisation: {
      default: "",
      type: String,
    },
    reply_metadata: {
      default: null,
      type: Object,
    },
    reply_message_uuid: {
      default: "",
      type: String,
    },
    reply_subject: {
      default: "",
      type: String,
    },
    reply_body: {
      default: "",
      type: String,
    },
    reply_attachments: {
      default: () => [],
      type: Array,
    },
    functionbox_uuid: {
      default: "",
      type: String,
    },
    show: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    SDKReferences,
    SDKSearch,
    SDKRecipients,
    FileSelect,
    Attachment,
  },
  data() {
    return {
      settings: null,
      identifier: "",
      addWithIdentifier: false,
      referencesIndex: 0,
      attachmentIndex: 0,
      disabledSend: false,
      step: 1,
      to_sdk: null,
      selected_functionbox_uuid: this.functionbox_uuid,
      functionbox_options: [],
      validated: [],
      content: "",
      subject: "",
      require_response: 1,
      today: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      set_loa_level: 0,
      loa_level: 3,
      emails: [],
      files: [],
      isconfidential: true,
      methods: [],
      loading: false,
      attachments: [],
      showExternal: false,
      participants: [],
      external_text: "",
      external_participants: [],
      process: 1,
      fromParticipantPersons: [],
      fromParticipantReferences: [],
      toParticipantPersons: [],
      toParticipantReferences: [],
      fields: [
        {
          thStyle: "width: 100%;",
          key: "authentication_identifier",
          class: "hidden-not-mobile",
          thClass: "hidden",
        },
        {
          thStyle: "width: 45%;",
          key: "email",
          class: "hidden-mobile",
          label: this.$t("EMAIL"),
          sortable: false,
        },
        {
          thStyle: "width: 45%;",
          key: "authentication_method",
          class: "hidden-mobile",
          label: this.$t("AUTH_METHODS.VERIFY"),
          sortable: false,
        },
        {
          thStyle: "width: 10%;",
          key: "language",
          class: "hidden-mobile",
          label: this.$t("LANGUAGE.TITLE"),
          sortable: false,
        },
      ],
    };
  },
  methods: {
    async okAddIdentifier() {
      let self = this;
      let SdkIdentifierDTO = {
        functionbox_uuid: this.functionbox_uuid,
        identifier: this.identifier,
      };
      self.loading = true;
      await this.$http
        .post(this.user.hostname + "/sdk/address/identifier", SdkIdentifierDTO)
        .then(function (result) {
          self.to_sdk = result.data;
          self.identifier = "";
          self.loading = false;
          self.addWithIdentifier = false;
        })
        .catch(function (error) {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          if (error.response != undefined) {
            self.$noty.error(self.$t(error.response.data));
          }
        });
    },
    cancelAddIdentifier() {
      this.identifier = "";
      this.addWithIdentifier = false;
    },
    setReferences(obj) {
      this.fromParticipantPersons = obj.fromParticipantPersons;
      this.fromParticipantReferences = obj.fromParticipantReferences;
      this.toParticipantPersons = obj.toParticipantPersons;
      this.toParticipantReferences = obj.toParticipantReferences;
      this.step = 1;
      this.referencesIndex++;
    },
    cancelReferences() {
      this.step = 1;
    },
    backBtn() {
      this.step = 1;
    },
    selectedAddress(item) {
      this.to_sdk = item;
      this.step = 1;
    },
    addNewSdkParticipant() {
      this.step = 5;
    },
    addSdkRecipient() {
      this.step = 4;
    },
    async searchReplyIdentifier() {
      let self = this;
      let SdkIdentifierDTO = {
        identifier: this.reply_identifier,
        functionbox_uuid: this.functionbox_uuid,
      };
      self.loading = true;
      await this.$http
        .post(this.user.hostname + "/sdk/address/identifier", SdkIdentifierDTO)
        .then(function (result) {
          self.to_sdk = result.data;
        })
        .catch(function (error) {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          if (error.response != undefined) {
            self.$noty.error(self.$t(error.response.data));
          }
        });
    },
    async shown(){
      this.getSettings();
    },
    getSettings() {
      let self = this;
      self.loading = true;
      this.$http
        .get(
          this.user.hostname + "/sdk/settings/" + this.functionbox_uuid
        )
        .then(function (result) {
          self.settings = result.data;
          self.init();
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH"));
        });
    },
    async init() {
      if (this.reply_metadata != null) {
        if (this.replyComplete) {
          this.toParticipantReferences =
            this.reply_metadata.ToParticipantReferences;
        } else {
          this.toParticipantReferences =
            this.reply_metadata.FromParticipantReferences;
        }
      }
      if (this.reply_identifier != "") {
        this.search_identifier = this.reply_identifier;
        this.search_organisation = this.reply_organisation;
        this.searchIdentifier();
      }
      this.subject = this.reply_subject;
      if (this.reply_body != "") {
        this.content = this.reply_body;
      } else {
        if (this.currentSignature != "") {
          this.content =
            "\n\n----------------------------\n" + this.currentSignature;
        }
      }
      this.attachments = this.reply_attachments.slice();
      if (this.showFrom) {
        for (let ix = 0; ix < this.user.functionboxes.items.length; ix++) {
          let functionbox = this.user.functionboxes.items[ix];
          if (ix == 0) {
            if (this.functionbox_uuid == "") {
              this.selected_functionbox_uuid = functionbox.functionbox_uuid;
            }
          }
          if (functionbox.sdk_enabled) {
            this.functionbox_options.push({
              value: functionbox.functionbox_uuid,
              text: functionbox.name + " - " + functionbox.email + "",
            });
          }
        }
      }
      /*setTimeout(() => {
        let input = document.getElementById("messageContent");
        input.setSelectionRange(0, 0);
      }, 500);*/
      this.loading = false;
    },
    async closeBtn() {
      this.$emit("changeShow", false);
      this.files = [];
      this.attachments = [];
      //this.$emit("sentMessage");
    },
    async showReferences() {
      this.step = 2;
    },
    async closeReferences() {
      this.step = 1;
    },
    async goBackStep1() {
      this.step = 1;
    },
    async goBackStep2() {
      this.step = 2;
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.attachmentIndex++;
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
      this.attachmentIndex++;
    },
    async getFileContent(file) {
      return new Promise((resolve) => {
        blobUtil
          .blobToBase64String(file)
          .then(function (base64String) {
            resolve(base64String);
          })
          .catch(function () {
            resolve(null);
          });
      });
    },
    async preSendMessage() {      
      this.disabledSend = true;
      this.loading = true;
      let self = this;
      if(this.settings.environment == 'PRODUCTION'){
        setTimeout(async function () {
          await self.sendMessage();
        }, 5000);
      }else{
        await self.preAcceptSendMessage();
      }
    },
    async preAcceptSendMessage(){
      let self = this;      
      let message = this.$t('SDK.ENVIRONMENT.QA_NOTIFICATION');
      if(this.settings.environment == 'OPEN_TEST'){
        message = this.$t('SDK.ENVIRONMENT.OPEN_TEST_NOTIFICATION');
      }
      message = message.replaceAll("<b>","")
      message = message.replaceAll("</b>","")
      this.$bvModal.msgBoxConfirm(message, {
        size: 'sm',
        title: this.$t('SDK.ENVIRONMENT.TEST'),
        buttonSize: 'sm',
        headerBgVariant: "danger",
        okVariant: 'primary',
        okTitle: this.$t('SUBMIT'),
        cancelTitle: this.$t('CANCEL'),
        dialogClass: this.teams.theme,
        bodyClass: 'messagebox',
        footerClass: 'p-2  text-center messagebox',
        hideHeaderClose: true,
        centered: true
      })
      .then(function(value){
        if(value)
        {          
          setTimeout(async function () {
            await self.sendMessage();
          }, 2000);
        }else{
          self.loading = false;
        }
      })
      .catch(function(){
        self.loading = false;
      }); 
    },
    async sendMessage() {
      try {
        for (let ix = 0; ix < this.files.length; ix++) {
          let base64Content = await this.getFileContent(this.files[ix]);
          if (base64Content == null) {
            //this.$noty.error(self.$t("ERROR.EXCEPTION"));
            return false;
          } else {
            this.attachments.push({
              name: this.files[ix].name,
              type: this.files[ix].type,
              content: base64Content,
              size: this.files[ix].size
            });
          }
        }
        this.files = [];
        this.attachmentIndex++;
        let self = this;
        if (this.external_text == "") {
          this.external_text = this.$t("MESSAGES.EXTERNAL_TEXT_PLACEHOLDER");
        }
        this.$http
          .post(this.user.hostname + "/sdk/secure", {
            functionbox_uuid: this.selected_functionbox_uuid,
            response_to_message_uuid: this.reply_message_uuid,
            subject: this.subject,
            body: this.content,
            attachments: this.attachments,
            participants: this.participants,
            external_text: this.external_text,
            to_sdk_identifier: this.to_sdk.attributes.identifier,
            fromParticipantPersons: this.fromParticipantPersons,
            fromParticipantReferences: this.fromParticipantReferences,
            toParticipantPersons: this.toParticipantPersons,
            toParticipantReferences: this.toParticipantReferences,
            isconfidential: this.isconfidential,
            settings: {
              require_response: parseInt(this.require_response),
              loa_level: parseInt(this.loa_level),
              open_to_date: null,
              open_from_date: null,
            },
          })
          .then(function (result) {
            self.attachments = [];
            self.$emit("changeShow", false);
            self.$emit("sentMessage");
            self.loading = false;
            if (result.data.all_sent != undefined) {
              if (result.data.all_sent) {
                self.$noty.info(self.$t("SENT_MESSAGE"));
              } else {
                self.$noty.warning(self.$t("SENT_MESSAGE_NOT_SENT"));
              }
            } else {
              self.$noty.info(self.$t("SENT_MESSAGE"));
            }
          })
          .catch(function (error) {
            self.loading = false;
            self.disabledSend = false;
            if(error.toString() == "Error: fail_4_4") return;
            if (error.response != undefined) {
              if (error.response.data.includes("ERROR.MESSAGE_STATUS.")) {
                let status = error.response.data.replace("ERROR.", "");                
                if(error.toString() == "Error: fail_4_4") return;
                self.$noty.error(self.$t(status));
              } else {
                self.$noty.error(self.$t(error.response.data));
              }
            }
          });
      } catch (error) {
        throw error;
      }
    },
    ValidateFileSize(bytes)
    { 
      return bytes < (this.GetMaxTotalBytesAllowedToSendSDKMessage*1024*1024);
    }
  },
  computed: {
    metadataItemsCount() {
      return (
        this.fromParticipantPersons.length +
        this.fromParticipantReferences.length +
        this.toParticipantPersons.length +
        this.toParticipantReferences.length
      );
    },
    referencesKey() {
      return "references_" + this.referencesIndex;
    },
    currentFilesize() {
      let filesize = 0;
      for (let ix = 0; ix < this.files.length; ix++) {
        filesize += this.files[ix].size;
      }
      return filesize;
    },
    currentSignature() {
      let self = this;
      let currentSignature = this.user.information.signature;
      if (this.functionbox_uuid != "") {
        let me = this.user.functionboxes.items.filter(
          (c) => c.functionbox_uuid == self.functionbox_uuid
        );
        if (me.length != 0) {
          currentSignature = me[0].signature;
        }
      } else {
        if (this.user_uuid != "") {
          let me = this.user.delegatedboxes.items.filter(
            (c) => c.user_uuid == self.user_uuid
          );
          if (me.length != 0) {
            currentSignature = me[0].signature;
          }
        }
      }
      return currentSignature;
    },
    showFrom: function () {
      return this.user.functionboxes.items.length != 0;
    },
    disabledGotoStep2: function () {
      if(!this.ValidateFileSize(this.currentFilesize))
      {
        return true;
      }
      if(this.to_sdk == null)
      {
        return true;
      }
      if(this.subject == "")
      {
        return true;
      }
      return false;
    },
    filesClass() {
      if(this.ValidateFileSize(this.currentFilesize))
      {
         return ["is-valid"];
      } else {
        return ["is-invalid"];
      }
    }
  },
  mounted() {
  },
};
</script>